import React from "react";
import "./style.css";

import { AboutInfo } from "../../data/Info";

const AboutText = () => {
  return (
    <div className="about-text">
      <AboutInfo />
    </div>
  );
};

export default AboutText;
